import { useStorage } from '@faststore/sdk'

const storageKey = 'main::store::searchHistory'

const MAX_HISTORY_SIZE = 2

export default function useSearchHistory(
  maxHistorySize: number = MAX_HISTORY_SIZE
) {
  const [searchHistory, setSearchHistory] = useStorage<string[]>(storageKey, [])

  function addToSearchHistory(term: string) {
    setSearchHistory((prev) => {
      if (prev.find((el) => el.toLowerCase() === term.toLowerCase()))
        return prev // it must be case insensitive: no duplicate entries for same word

      const newHistory = [...new Set([term, ...prev])]
      return newHistory.length > maxHistorySize
        ? newHistory.slice(0, maxHistorySize)
        : newHistory
    })
  }

  function deleteFromSearchHistory(term: string) {
    setSearchHistory((prev) => prev.filter((item) => item !== term))
  }

  function clearSearchHistory() {
    setSearchHistory([])
  }

  return {
    searchHistory,
    addToSearchHistory,
    deleteFromSearchHistory,
    clearSearchHistory,
  }
}
